import { render, staticRenderFns } from "./IzvjestajiHKIE.vue?vue&type=template&id=195ced14&scoped=true&"
import script from "./IzvjestajiHKIE.vue?vue&type=script&lang=js&"
export * from "./IzvjestajiHKIE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195ced14",
  null
  
)

export default component.exports